import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import store from '../../states/Store';
import Service from '../../classes/Service';
import Quote from '../../classes/Quote';
import Factory from '../../classes/Factory';
import QuoteTable from '../tables/QuoteTable';

const parse = Quote.deserialize;
const headers = ['', 'Type', 'Term', 'Rate'];
const properties = ['Enabled', 'Type', 'Maturity', 'Value']
const isAlignLeft = [true, true, true, false];
const isInput = [true, false, false, true];


export default function SyntheticPage() {
  const { ccy } = useParams<{ ccy: string }>();
  const tenors = ['OIS', '1M', '3M', '6M'];
  const [synthetics, setSynthetics] = useState([] as Quote[][])

  const service = async () => {
    const quotes = store.MarketData.Current.Quotes
      .getValue()
      .filter((quote) => 
        quote && quote.Type !== '' 
        && (quote.Value !== '' || (quote.Type === 'FUT' && quote.Yield !== '')));
    if (Factory.IsNullOrEmpty(quotes)) return;
    const values: string[][] = await Service.post('market', 'CreateSyntheticInstruments', JSON.stringify(getData(quotes)));
    const synthetics: Quote[][] = values.map(array => array.map(str => parse(str)));
    store.MarketData.Current.SyntheticQuotes.next(synthetics);
  }

  // Should be a FRA as we are sending back a rate (not even a yield as it is adjusted)
  // Change 'FUT' to 'FRA'
  // Change Maturity from Future Code to start/end dates (start date being the future delivery)
  const filterFuture = (quotes: Quote[], tenor: string) => 
    quotes
      .filter((quote) => 
        quote.Type === 'FUT' 
        && quote.Tenor === tenor 
        && quote.Yield !== '')
      .map((future: Quote) => `${future.Currency}.FUT.${tenor}.${future.Maturity}:${future.Yield}`);

  const filter = (
    quotes: Quote[],
    type: string,
    tenor: string | null = null,
    frequency: string | null = null) =>
    quotes
      .filter((quote) =>
        quote.Type === type
        && (!tenor || quote.Tenor === tenor)
        && (!frequency || quote.FixedFrequency === frequency)
        && quote.Value !== '')
      .map((quote) => Quote.serialize(quote))

  const getData = (quotes: Quote[]): any => {
    const valuationDate: Date = store.MarketData.ValuationDate.getValue();
    return {
      currency: ccy,
      valuationDate: valuationDate.ToAODate(),
      deposits: filter(quotes, 'DEPO'),
      swapsOIS: filter(quotes, 'OIS'),
      futureOIS: filterFuture(quotes, 'OIS'),
      future1M: filterFuture(quotes, '1M'),
      future3M: filterFuture(quotes, '3M'),
      future6M: filterFuture(quotes, '6M'),
      swaps1M: filter(quotes, 'IRS', '1M'),
      swaps3M: filter(quotes, 'IRS', '3M'),
      swaps6M: filter(quotes, 'IRS', '6M'),
      basis0s3s: filter(quotes, 'DBS', 'OIS', '3M'),
      basis1s3s: filter(quotes, 'DBS', '1M', '3M'),
      basis3s6s: filter(quotes, 'DBS', '3M', '6M'),
    }
  }

  useEffect(() => {
    store.MarketData.Current.SyntheticQuotes.subscribe((synthetics) => setSynthetics(synthetics));
    service();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='SyntheticPage'>
      {tenors.map((tenor: string, index: number) =>
        !synthetics[index] ? '' :
          (<QuoteTable
            key={tenor}
            legend={`Curve  ${tenor}`}
            headers={headers}
            properties={properties}
            quotes={synthetics[index].filter((quote: Quote) => quote.Value !== '')}
            isAlignLeft={isAlignLeft}
            isInput={isInput} />)
      )}
    </div>);
}
